<h3 class="header">
  <ng-content select="[header]"></ng-content>
</h3>
<p class="subheader">
  <ng-content select="[subheader]"></ng-content>
</p>
<div class="buttons">
  <ng-content select="[buttons]"></ng-content>
</div>
